module.exports = __webpack_public_path__ + "static/media/truckenv_blue.df002ec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/truckenv_blue.svg
// module id = 900
// module chunks = 0